import React, { useEffect } from "react";
import { Card, CardBody } from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import { useQuery, gql, useMutation } from "@apollo/client";
import moment from "moment";
import {
  CircularProgress,
  Grid,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import TableView from "./TableView";

import { Delete } from "@material-ui/icons";
import TableViewCustomerBased from "./TableViewCustomerBased";

const useStyles = makeStyles(() => ({
  heading: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "16px",
    fontWeight: "600"
  },
  time: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "10px"
  },
  body: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px",
    overflow: "hidden"
  },
  type: {
    backgroundColor: "yellow",
    padding: "5px",
    fontSize: "10px"
  },
  postId: {
    color: "red",
    fontWeight: "bold"
  }
}));
const MEETINGNOTES = () => gql`
  query customer(
    $id:ID!
  ) {
    customer(
      id:$id
    ) {
        FullName
        Email
        Company
        Designation
        meeting_notes{
          id
          MeetingRemarks
          added_by {
            username
          }
          created_at
        }
    }
  }
`;

export default function AllMeetingNotesCustomerBased(props) {
  const classes = useStyles();
  const { data, loading, error } = useQuery(MEETINGNOTES(), {
    variables: {
      id:props.selectedCustomerId
    }
  });


  useEffect(() => {
    if (data) {
      props.setPageDataCount(data.length);
    }
  }, [data]);

  return (
    <Grid container spacing={2}>
      {loading ? (
        <CircularProgress />
      ) : props.viewType === "card" ? (
        !loading &&
        !error &&
        data &&
        data.customer && data.customer.meeting_notes.map((post, idx) => (
          <Grid container item lg={3} key={idx}>
            <Card
              small
              className="card-post h-100"
              style={{
                width: "100%",
                borderBottom:
                  post.published_at === null ? "4px solid red" : "none"
              }}
            >
              <CardBody style={{ marginBottom: "30px" }}>
                <NavLink
                  tag={RouteNavLink}
                  to={`/meetingNote/${post.id}`}
                  style={{ padding: "0px" }}
                >
                  <Typography
                    className={classes.postId}
                    style={{ color: "#3D5170" }}
                  >
                    {data.customer && data.customer.Company}
                  </Typography>
                </NavLink>
                <NavLink
                  tag={RouteNavLink}
                  to={`/meetingNote/${post.id}`}
                  style={{ padding: "0px" }}
                >
                  <span className={classes.time}>
                    {moment(post.created_at).format("DD/MM/YYYY hh:mm a")}
                  </span>
                </NavLink>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    // position: "absolute",
                    // bottom: "10px",
                    // right: "0px",
                    borderTop: "1px solid #eee",
                    paddingTop: "10px"
                  }}
                >
                  <Grid container>
                    <Typography>{data.customer && data.customer.FullName}</Typography>
                  </Grid>
                  <Grid container>
                    <Typography>{data.customer && data.customer.Designation}</Typography>
                  </Grid>
                  <Grid container>
                    <Typography>{data.customer && data.customer.Email}</Typography>
                  </Grid>
                </Grid>
              </CardBody>
            </Card>
          </Grid>
        ))
      ) : (
        !loading &&
        !error &&
        data && (
          <Grid
            container
            style={{
              padding: "10px"
            }}
          >
            <TableViewCustomerBased data={data} />
          </Grid>
        )
      )}
    </Grid>
  );
}
